var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationfooter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.806641,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#457AD0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 24.2649C23.2817 24.2649 22.5928 23.9796 22.0849 23.4717C21.577 22.9638 21.2917 22.2749 21.2917 21.5566C21.2917 20.8383 21.577 20.1494 22.0849 19.6415C22.5928 19.1336 23.2817 18.8483 24 18.8483C24.7183 18.8483 25.4072 19.1336 25.9151 19.6415C26.423 20.1494 26.7083 20.8383 26.7083 21.5566C26.7083 21.9123 26.6383 22.2644 26.5022 22.593C26.3661 22.9216 26.1666 23.2202 25.9151 23.4717C25.6636 23.7232 25.365 23.9227 25.0364 24.0588C24.7078 24.1949 24.3557 24.2649 24 24.2649ZM24 13.9733C21.9888 13.9733 20.0599 14.7722 18.6378 16.1944C17.2156 17.6165 16.4167 19.5454 16.4167 21.5566C16.4167 27.2441 24 35.6399 24 35.6399C24 35.6399 31.5833 27.2441 31.5833 21.5566C31.5833 19.5454 30.7844 17.6165 29.3622 16.1944C27.9401 14.7722 26.0112 13.9733 24 13.9733Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationfooter);
export default __webpack_public_path__ + "static/media/locationfooter.62aa7979e0ee3238df0f51ae55ea888c.svg";
export { ForwardRef as ReactComponent };